/* eslint-disable import/prefer-default-export */
import moment from 'moment';

/**
 * @param {Date} startBiddingTime
 * @param {Date} endBiddingTime
 * @param {any} t
 * @returns {string}
 */
export const getBidTimePeriodLabel = (startBiddingTime, endBiddingTime, t) => {
    const start = moment(startBiddingTime).format('LT');
    const end = moment(endBiddingTime).format('LT');
    return t('form.schedulePeriod.bidTimePeriodValueLabel', { start, end });
};
